import React from 'react'

import QuizTile from '../QuizTile/QuizTile'
import { PuzzleIcon } from '../Icons'
import { EmptyState } from '../EmptyState/EmptyState'

import { ResultsGrid } from './styled'

import { IQuiz } from 'src/api/quizzes/types'

interface IQuizListProps {
  quizzes: IQuiz[]
  complete?: boolean
}

const QuizList: React.FC<IQuizListProps> = ({ quizzes, complete = false }) => {
  if (quizzes.length === 0) {
    return (
      <EmptyState
        icon={PuzzleIcon}
        title="No quizzes yet"
        body="New quizzes will live here"
      />
    )
  }

  return (
    <ResultsGrid>
      {quizzes.map((quiz) => (
        <QuizTile key={quiz.id} quiz={quiz} complete={complete} />
      ))}
    </ResultsGrid>
  )
}

export default QuizList
